import { ActionButtons } from '@/components/molecules/ActionButtons';

interface Props {
	handleSubmit: () => void;
	handleCancel: () => void;
	textWarningArray: string[];
}
export const AlertScoreModalContent = ({ handleCancel, handleSubmit, textWarningArray }: Props) => {
	return (
		<>
			<div className="py-3">
				<p className="text-sm font-medium">The entered scores contain the following irregularities:</p>

				<ul className="space-y-2 pl-2 py-4">
					{textWarningArray.map((textItem, index) => (
						<li key={index} className="flex items-start gap-2.5">
							<div className="mt-1.5 size-2 shrink-0 rounded-full bg-gray-800"></div>
							<span className="text-sm text-gray-900">{textItem}</span>
						</li>
					))}
				</ul>

				<p className="text-sm font-medium">Would you still like to save these scores?</p>
			</div>

			<ActionButtons
				className="flex justify-end gap-3"
				closeButtonClassName="w-32 text-gray-700"
				submitButtonClassName="min-w-36 bg-orange-500 text-white hover:bg-orange-700"
				onClose={handleCancel}
				onSubmit={handleSubmit}
				submitButtonText="Save Anyway"
				closeButtonText="Cancel"
				submitButtonDisabled={false}
			/>
		</>
	);
};
